import { useSelector } from "react-redux";
import AuthRouter from "./AuthRouter";
import AdminRouter from "./AdminRouter";
import PermissionProvider from "../permission/PermissionProvider";

export default function AllRoutes() {
    const user = useSelector((state) => state?.auth)
    // console.log(user)
    const userPermissions = user?.after_login_data?.data?.role?.permissions
    const permissionsName = userPermissions?.map(data => data?.name)
    // console.log(permissionsName)
    return (
        (
            user?.isLoggedIn ? (
                // <AdminRouter />
                // <PermissionProvider permissions={permissionsName}>
                //     <AdminRouter />
                // </PermissionProvider>
                <AdminRouter />
            ) : (
                <AuthRouter />
            )
        )
    )
}